/*global angular */
/*jslint node: true */

'use strict';

var headline = angular.module('headline', []);
headline.directive('headlineSlot', ['$templateCache', function ($templateCache) {
    return {
        restrict: 'E',
        template: $templateCache.get('slots/headline/headline.html')
    };
}]);
